import React, {Component} from 'react';

export default class ActionsBox extends Component{
  constructor(props) {
    super(props);
    this.seeSurvey=this.seeSurvey.bind(this);
    this.seeReport=this.seeReport.bind(this);
    this.doneClick=this.doneClick.bind(this);
    this.getLink=this.getLink.bind(this);
    this.donerClick=this.donerClick.bind(this);
    this.getrLink=this.getrLink.bind(this);
    this.state={success:"",vallink:false,link:"", reportlink:false,replink:"",noschange:false,norchange:false,consurv:"",conrep:"",error:""};
  }
  seeSurvey(event)
  {

  }
  seeReport(event)
  {

  }
  doneClick(link)
  {
    this.props.handleslink(link);
    this.setState({error:""});
  }
  getLink()
  {
    var re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;
     this.setState({vallink:re.test(this.refs.slink.value.trim())});
  }
  donerClick(link)
  {
      if(this.props.info.surveylink!="")
      {
          this.props.handlerlink(link);
          this.setState({error:""});
      }
      else {
            this.setState({error:"Please enter survey link first."});
      }

  }
  getrLink()
  {
    var re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;;
     this.setState({reportlink:re.test(this.refs.rlink.value.trim())});
  }
  render(){
    var st={
      box:{

        borderRadius: "7px",
        borderTopRightRadius:0,
        borderTopLeftRadius:0,
        backgroundColor:"#ffffff",
        boxShadow: "0 3px 5px 0 rgba(0, 0, 0, 0.3)"
      },
      thickline:{
        height:"11.1px",
        backgroundColor:"#1a84eb",
        borderBottomRightRadius:0,
        borderBottomLeftRadius:0,
      },
      noborder:{
        border:'none',
      },
      btn:{
        outline: 'none !important',
        padding:0,
      },
    };
    var contentSurvey,contentReport,surveyCname,reportCname,eclass,rclass;

    if(this.state.vallink)
    {
      eclass="modal-body form-group has-success"
    }
    else {
      eclass="modal-body form-group has-error"
    }
    if(this.state.reportlink)
    {
      rclass="modal-body form-group has-success"
    }
    else {
      rclass="modal-body form-group has-error"
    }
    if(this.props.info.surveylink!="")
    {
      contentSurvey=<a href={this.props.info.surveylink}>{this.props.info.surveylink}</a>;
      surveyCname="btn-link";
    }
    else
    {
      contentSurvey="Not Available";
      surveyCname="text-muted";
    }
    if(this.props.info.reportlink!="")
    {

      contentReport=<a href={this.props.info.reportlink}>{this.props.info.reportlink}</a>;
      reportCname="btn-link";
    }
    else
    {
      contentReport="Not Availabe";
      reportCname="text-muted";
    }
    var sbtn,rbtn;
    if(this.props.info.status=="archived")
    {
      sbtn="";
      rbtn="";
    }
    else {
      sbtn=<button type="button" style={st.btn} className="btn btn-link"   data-toggle="modal" data-target="#myModal3"><strong>ENTER</strong></button>;
      rbtn=<button type="button" style={st.btn} className="btn btn-link" data-toggle="modal" data-target="#myModal2" ><strong>ENTER</strong></button>;
    }
    var success=""
    if (this.state.success) {
      success=<div className="text-success">Link Added Successfully</div>
    }
    return(
        <div>
          <div className="img-rounded" style={st.thickline}></div>
          <div className="panel panel-default" style={st.box}>
            <div className="panel-body">
              <table className="table" style={{wordWrap:"break-word",tableLayout: 'fixed'}}>
                <tbody>
                  <tr>
                    <td style={st.noborder}><strong>ACTIONS</strong></td>
                  </tr>
                  <tr>
                    <td style={st.noborder}><strong>Survey:</strong> <span className={surveyCname}>{contentSurvey}</span></td>
                    <td style={st.noborder} className="text-right" >{sbtn}</td>
                  </tr>
                  <tr>
                    <td style={st.noborder}><strong>Report:</strong> <span className={reportCname}>{contentReport}</span></td>
                    <td style={st.noborder} className="text-right" >{rbtn}</td>
                  </tr>
                </tbody>
              </table>
              <p className="text-danger">{this.state.error}</p>
            </div>
          </div>
            <Mod1 handlesdone={this.doneClick}/>
            <Mod2 handlesdone={this.donerClick} />

        </div>
    );
  }
}
class Mod1 extends Component
{
  constructor(props)
  {
    super(props);
    this.state={error:""};
    this.checkDone=this.checkDone.bind(this);
  }
  checkDone()
  {

      if(this.refs.slink.value.trim()=="")
      {
        this.setState({error:"Please enter the link",success:""});
      }
      else {
        this.setState({error:"",success:"Link Added successfully"});
        this.props.handlesdone(this.refs.slink.value.trim());
      }
  }
  render()
  {
    return(
      <div className="modal fade" id="myModal3" role="dialog">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">&times;</button>
              <h4 className="modal-title">Enter link of the survey form</h4>
            </div>
            <div className="modal-body form-group">
              {this.state.success}
              <p className="text-danger">{this.state.error}</p>
          <div className="row">
            <div className="col-md-10">
              <input type="text" className="form-control " ref="slink" id="usr"/>
            </div>
            <div className="col-md-2">
              <button type="button" className="btn btn-default" onClick={this.checkDone}>Done</button>
            </div>
            </div>
          </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
            </div>

          </div>
        </div>

      </div>


    );
  }
}
class Mod2 extends Component{

  constructor(props)
  {
    super(props);
    this.state={error:""};
    this.checkDone=this.checkDone.bind(this);
  }
  checkDone()
  {

      if(this.refs.slink.value.trim()=="")
      {
        this.setState({error:"Please enter the link"});
      }
      else {
        this.setState({error:""});
        this.props.handlesdone(this.refs.slink.value.trim());
      }
  }
  render()
  {
      return(
        <div className="modal fade" id="myModal2" role="dialog">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">&times;</button>
                <h4 className="modal-title">Enter link of Report</h4>
              </div>
              <div className="modal-body form-group">
              <p className="text-success">{this.state.success}</p>
              <p className="text-danger">{this.state.error}</p>
              <div className="row">
                <div className="col-md-10">
                  <input type="text" className="form-control " ref="slink" id="usr"/>
                </div>
                <div className="col-md-2">
                  <button type="button" className="btn btn-default" onClick={this.checkDone}>Done</button>
                </div>
              </div>
            </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal" >Close</button>
              </div>
            </div>
          </div>
        </div>
      );
  }

}



/** WEBPACK FOOTER **
 ** ./src/views/Home/actions.js
 **/